var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.2 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01 0h49.17c1.66.01 3.01 1.37 3.01 3.03v32.33c0 1.67-1.36 3.03-3.03 3.03H3.01C1.35 38.39 0 37.03 0 35.37V3.03C0 1.37 1.35.01 3.01 0z",
    fill: "#ed2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01 0H37.2v38.4H3.02A3.045 3.045 0 010 35.37V3.03C0 1.37 1.35.01 3.01 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01 0H18v38.4H3.02A3.045 3.045 0 010 35.37V3.03C0 1.37 1.35.01 3.01 0z",
    fill: "#002395"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.0ed2ae97630c7efc5a6857335a84eaea.svg";
export { ForwardRef as ReactComponent };